// Use this HOC in state config with "component" property (instead of "template")
import { useRouter } from "@uirouter/react";
import type { UIRouter } from "@uirouter/core";

export const withUIRouter = (Component) => {
    return function (props) {
        const router = useRouter();
        return (
            <Component
                {...props}
                router={router}
            />
        );
    };
};

export type WithUIRouterProps = UIRouter;
